const translations = {
    back: 'Return to Customers',
    invoices: 'Invoices',
    newInvoice: 'New Invoice'
};

export default translations;
